import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Header from "../../../components/home/Header";
import Nav from "../../../components/home/Nav";

const Register = () => {
  return (
    <>
      <Nav />

      <div className="mt-[70px] pb-[80px]">
        <Header>ایجاد حساب کاربری</Header>

        <div className="flex flex-wrap justify-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            className="w-full sm:w-10/12 md:w-8/12 lg:w-6/12 xl:w-4/12 p-6"
          >
            <div className="auth-card-modern">
              <div className="auth-card-head">
                <span>ورود سریع</span>
                <h1>ثبت‌نام جداگانه لازم نیست</h1>
                <p>
                  در جوتی حساب کاربری با شماره موبایل ساخته می‌شود. کافی است
                  شماره موبایل خود را وارد کنید و با کد تایید وارد شوید.
                </p>
              </div>

              <Link to="/login" className="btn btn-primary w-full text-center">
                ورود یا ایجاد حساب با موبایل
              </Link>

              <div className="auth-card-footer">
                <Link to="/">بازگشت به صفحه اصلی</Link>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Register;